import { Injectable } from '@angular/core';

import { RumInitConfiguration } from '@datadog/browser-rum';

import { ClientConfigProductName } from '../client-config/client-config-product-name.model';
import { ClientConfig } from '../client-config/client-config.decorator';
import { ClientConfigService } from '../client-config/client-config.service';
import { ProductService } from '../products/product.service';

/**
 * @stable
 */
@ClientConfig({ key: 'haDatadog', product: ClientConfigProductName.HOST })
@Injectable({
    providedIn: 'root',
    deps: [ClientConfigService, ProductService],
    useFactory: datadogRumConfigFactory,
})
export class DatadogRumConfig {
    isEnabledCondition: string;
    initOptions: RumInitConfiguration;
    globalContextProperties: Record<string, string>;
}
export function datadogRumConfigFactory(service: ClientConfigService, productService: ProductService) {
    return productService.isSingleDomainApp ? service.get(DatadogRumConfig) : {};
}
